import { Document, Font, Page, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { detalleTest, resumenTest } from './testData';
import TopBlock from './components/TopBlock';
import BodyBlock from './components/BodyBlock';
import SignBlock from './components/SignBlock';
import DisclaimerBlock from './components/DisclaimerBlock';

Font.registerHyphenationCallback(word => [word]);

function PDFComponent({ resumen = resumenTest, detalle = detalleTest, allDetalleState }) {
    const pageStyle = {
        display: 'flex',
        border: '8px solid #32b8df',
        fontSize: '8px',
        padding: '8px',
        color: '#2e373b'
    };

    const pageCounter = {
        position: 'absolute',
        bottom: '4px',
        right: '4px',
        fontSize: '10px'
    };

    let pages = 1;
    if (detalle.length >= 37)
        pages = 2;

    let bodyData = [];
    const sliceIndex = detalle.length === 37 ? 31 : 44;

    if (pages > 1) {
        bodyData.push(detalle.slice(0, sliceIndex));
        bodyData.push([detalle[0], ...detalle.slice(sliceIndex)]);
    } else {
        bodyData.push(detalle);
    }


    return (

        <Document>
            <Page
                size="LETTER"
                orientation="portrait"
                style={pageStyle}
            >
                <TopBlock detalle={detalle} resumen={resumen} allDetalleState={allDetalleState}/>

                {/* {bodyData.map((arr, i) => (
                    <BodyBlock
                        key={i}
                        breakPage={i > 0}
                        arsr={arr}
                    />
                ))} */}

                <SignBlock />

                <DisclaimerBlock />

                <Text style={pageCounter} render={({ pageNumber, totalPages }) => (
                    `Página ${pageNumber} de ${totalPages}`
                )} fixed />
            </Page>
        </Document>

    );
}

export { PDFComponent };
